export default {
  "content": "<g clip-path=\"url(#icon_chat_filled_svg__a)\"><path fill-rule=\"evenodd\" d=\"M12 8a4 4 0 014 4c0 .752-.211 1.453-.572 2.053l.561 1.684a.2.2 0 01-.253.252l-1.683-.56A3.98 3.98 0 0112 16a4 4 0 010-8z\" clip-rule=\"evenodd\"/><path d=\"M0 6a6 6 0 1111.917 1A5 5 0 007 11.918a5.962 5.962 0 01-4.08-.775l-2.524.842a.3.3 0 01-.38-.38L.858 9.08A5.966 5.966 0 010 6z\"/><path d=\"M8.015 11.653a6.018 6.018 0 003.638-3.638 4.001 4.001 0 00-3.638 3.638z\"/></g><defs><clipPath id=\"icon_chat_filled_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};